import { lazyPage } from "@/router/lazyPage";

export const AuthCallback = lazyPage(() => import("@/pages/AuthCallback"), "AuthCallback");
export const Login = lazyPage(() => import("@/pages/Login"), "Login");
export const MobileAuthCallback = lazyPage(
  () => import("@/pages/MobileAuthCallback"),
  "MobileAuthCallback",
);
export const Register = lazyPage(() => import("@/pages/Register"), "Register");
export const Terms = lazyPage(() => import("@/pages/Legal"), "Terms");
export const Privacy = lazyPage(() => import("@/pages/Legal"), "Privacy");
